import { render, staticRenderFns } from "./SimulationsList.view.vue?vue&type=template&id=15d452ae"
import script from "./SimulationsList.view.vue?vue&type=script&lang=ts"
export * from "./SimulationsList.view.vue?vue&type=script&lang=ts"
import style0 from "./SimulationsList.view.vue?vue&type=style&index=0&id=15d452ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDataTable,VFooter,VIcon,VRow,VTooltip})
